import {IDictionary} from "@/shared/models/interface/dictionary-model";
import {IFixedFilter} from "@/shared/models/view/fixed-filter-model";
import {IAzureSearchResponse, IAzureSearchService, Query} from "@/shared/services/azure-search-service";
import {IAzureSearchMapper} from "../mappings/base-search-response-mapper";
import {IFilterItem} from "../models/filter-item-model";
import {ISearchService} from "./interfaces/search-service-interface";

export abstract class BaseSearchService<T> implements ISearchService<T> {
    readonly abstract azureService: IAzureSearchService
    readonly abstract mapper: IAzureSearchMapper<T>

    public searchQuery: Query = new Query
    public filterQuery: string = ""

    public loading: boolean = false
    public failed: boolean = false

    public abstract setFilterQuery(
        fixedFilters: IDictionary<IFixedFilter>,
        scopes: IFilterItem[],
        filters: IDictionary<IFilterItem[]>): void;

    public abstract setSearchQuery(
        order: string,
        query: string,
        skip: number,
        limit: number): void;

    public async loadData(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.azureService.search(this.searchQuery)
                .then((response: IAzureSearchResponse<T>) => {
                    resolve(this.mapper.createResponse(response))
                })
                .catch((error: Error) => {
                    reject(error)
                })
        })
    }
}
